function renderMarkdownFieldChangeHandlerTemplate({
  indent,
  defaultValueFromHandler
}: {
  indent: string
  defaultValueFromHandler: string
}): string {
  return `(value) => {
${indent}            ${defaultValueFromHandler}(value)
${indent}            formField.onChange(value)
${indent}          }`
}

function renderMarkdownFieldFormFieldTemplate({
  indent,
  fieldName,
  fillFormItemProps,
  labelWithDescription,
  onChange,
  fillControlClass,
  toLowerCase
}: {
  indent: string
  fieldName: string
  fillFormItemProps: string
  labelWithDescription: string
  onChange: string
  fillControlClass: string
  toLowerCase: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${fillFormItemProps}>
${indent}      ${labelWithDescription}
${indent}      <FormControl>
${indent}        <ContentEditor
${indent}          value={formField.value}
${indent}          onChange={${onChange}}
${indent}          defaultMode="source"
${indent}          className="${fillControlClass}"
${indent}          placeholder="Enter ${toLowerCase}"
${indent}        />
${indent}      </FormControl>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}

export function renderMarkdownFieldRenderer(
  request:
    | {
        kind: 'renderMarkdownFieldChangeHandlerTemplate'
        props: {
          indent: string
          defaultValueFromHandler: string
        }
      }
    | {
        kind: 'renderMarkdownFieldFormFieldTemplate'
        props: {
          indent: string
          fieldName: string
          fillFormItemProps: string
          labelWithDescription: string
          onChange: string
          fillControlClass: string
          toLowerCase: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderMarkdownFieldChangeHandlerTemplate':
      return renderMarkdownFieldChangeHandlerTemplate(request.props)
    case 'renderMarkdownFieldFormFieldTemplate':
      return renderMarkdownFieldFormFieldTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
